<template>
  <b-row class="info-desactivation d-flex bg-white align-items-center text-center h-100 py-1 mx-0">
    <b-col
      v-if="content.texteDesactivation"
      class="de-retour-bientot graphik_semibold align-self-center"
      v-html="content.texteDesactivation"
    >
    </b-col>
    <b-col v-else class="align-self-center">
      <p class="jeu-non-disponible graphik_bold p-0">
        {{ $t('jeuNonDisponible') }}
      </p>
      <p class="de-retour-bientot graphik_semibold p-0">
        {{ $t('deRetourBientot') }}
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CarteInfoSecondaireDesactivation',
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        deRetourBientot: 'De retour bientôt',
        jeuNonDisponible: 'Jeu non disponible',
      },
      en: {
        deRetourBientot: 'Back soon',
        jeuNonDisponible: 'Game unavailable',
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.jeu-non-disponible {
  color: $gris-casino;
  margin-bottom: 1px;
}
.info-desactivation {
  border-bottom: 1px solid #e6e6e6;
  justify-content: center;
}
.de-retour-bientot {
  align-self: center;
  color: black;
  justify-content: center;
  ::v-deep p {
    display: -webkit-box;
    font-family: inherit;
    overflow: hidden;
    padding: 0;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
